<script>
export default {
  data: () => ({}),
  methods: {
    handlerOpen() {
      if (window.OmniWidgetApi) {
        window.OmniWidgetApi.call('open_widget');
      }
    },
  },
};
</script>
<template>
  <v-list-item
    @click="handlerOpen"
  >
    <v-list-item-action>
      <v-icon>mdi-message-text</v-icon>
    </v-list-item-action>
    <v-list-item-title>Написать</v-list-item-title>
  </v-list-item>
</template>
<style lang="scss">
</style>
